import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { DbHistoryDialog } from '@pt/pt-models';
import { DbHistoryDialogComponent } from '../dialogs';

@Injectable({
  providedIn: 'root'
})
export class HistoryDialogService {

  constructor(private modalService: NgbModal) {
  }

  runHistoryDialog = (historyDialog: DbHistoryDialog) => {
    const modalRef = this.modalService.open(DbHistoryDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
      // windowClass: 'md-620'
    });
    modalRef.componentInstance.init(historyDialog)
    return from(modalRef.result);
  };
}
